export const HELP_PAGE_URL = 'https://duckduckgo.com';
export const API_HOST = 'https://example.com';
export const PRICING_PAGE_URL = 'https://example.com/pricing';
export const APP_URL = 'https://example.com';
export const API_DOCUMENTATION_URL = 'https://example.com/api-documentation';
